import React, { PropsWithChildren, ReactNode } from 'react';
import cn from 'classnames';
import Button from '@components/Button';
import styles from '../Onboarding.module.scss';
import { LoaderIcon } from '@repo/icons';

export function FinishStepButton({
  className,
  children,
  onClick,
  disabled,
  disabledMsg,
  loading,
  errorMsg,
}: {
  className?: string;
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  disabledMsg?: string;
  loading?: boolean;
  errorMsg?: string;
}) {
  const renderDisabledMsg = disabled && disabledMsg && !loading && !errorMsg;
  const renderErrorMsg = errorMsg && !loading;

  return (
    <div className={cn(styles.btnContainer, className)}>
      <Button className={styles.btn} onClick={onClick} disabled={disabled}>
        {children}
      </Button>
      {renderDisabledMsg && <div className={styles.warning}>{disabledMsg}</div>}
      {loading && (
        <div className={styles.loading}>
          <LoaderIcon />
        </div>
      )}
      {renderErrorMsg && <div className={styles.error}>{errorMsg}</div>}
    </div>
  );
}

export default function CopySection({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return <div className={cn(styles.prompt, className)}>{children}</div>;
}
